// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"33a8c587","455":"404aa505","977":"ecbb9596"}[chunkId] + ".chunk.js";
};